export enum TermTypes {
  SelectBox = 1,
  Date = 2,
  CheckBox = 3,
  PlainText = 4,
  Custom = 5,
  TextArea = 6,
  Input = 7,
}
